<template>
	<div class="container" :style="{ 'height': height }">
		<div id="demo"></div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
	import Pdfh5 from "pdfh5";
	import "pdfh5/css/pdfh5.css";
	import { clutureList, } from '@/api/public';
	export default {
		name: 'pdf-h5',
		components: {
			//
		},
		data() {
			return {
				isLoading: true, //界面loading
				pdfh5: null,
				textData: '',
				pdfUrl: '',
				height: '2200px',
			}
		},
		created() {
			//
		},
		mounted() {
			let that = this;
			clutureList({
				id: 1,
			}).then(res => {
				this.pdfUrl = res.data.url;
				this.initPdf();
				// that.isLoading = false;
			});
		},
		watch: {
			//
		},
		methods: {
			initPdf() {
				let that = this;
				that.pdfh5 = ''
				that.pdfh5 = new Pdfh5("#demo", {
					pdfurl: that.pdfUrl, //pdf文件地址
					lazy: true, //是否懒加载,默认false
					renderType: 'canvas', // canvas、svg，默认canvas
					maxZoom: 3, //手势缩放最大倍数,默认3
					scrollEnable: true, //是否允许pdf滚动,默认true
					zoomEnable: true, // 是否允许pdf手势缩放,默认true
					limit: 0, //限制pdf加载最大页数,默认0不限制
				})
				//监听完成事件
				that.pdfh5.on("complete", function(status, msg, time) {
					that.isLoading = false;
					// console.log("状态：" + status + "，信息：" + msg + "，耗时：" + time + "毫秒，总页数：" + this.totalNum)
				})
			},
		}
	}
</script>

<style scoped>
	.pad_box {
		position: absolute;
		width: 100%;
		height: 100%;
	}
</style>